// src/native/bridge.js
// Jembatan Capacitor ↔ web. Tujuan Fase 1: JWT tersimpan di penyimpanan native
// (Preferences) yang persist & tidak ikut terhapus seperti cache WebView, TANPA
// mengubah AuthContext yang memakai localStorage secara sinkron.
//
// Strategi: SEBELUM React render, hydrate localStorage dari Preferences
// (initNative dipanggil di index.js dan di-await). Setelah itu setiap perubahan
// auth_token/auth_user di localStorage dicerminkan balik ke Preferences.
//
// Di web biasa (bukan APK) semua ini no-op — Capacitor.isNativePlatform() false.

import { Capacitor } from '@capacitor/core';

const KEYS = ['auth_token', 'auth_user'];
let native = false;

export function isNative() { return native; }

export async function initNative() {
  native = Capacitor.isNativePlatform();
  if (!native) return;

  const { Preferences } = await import('@capacitor/preferences');
  const { App } = await import('@capacitor/app');
  const { StatusBar, Style } = await import('@capacitor/status-bar').catch(() => ({}));

  // 1) Hydrate localStorage dari Preferences (sumber kebenaran di native).
  for (const k of KEYS) {
    const { value } = await Preferences.get({ key: k });
    if (value != null) localStorage.setItem(k, value);
    else localStorage.removeItem(k);
  }

  // 2) Cermin balik: bungkus setItem/removeItem/clear agar perubahan token
  //    langsung tersimpan ke Preferences (write-through).
  const origSet = localStorage.setItem.bind(localStorage);
  const origRemove = localStorage.removeItem.bind(localStorage);
  const origClear = localStorage.clear.bind(localStorage);

  localStorage.setItem = (k, v) => {
    origSet(k, v);
    if (KEYS.includes(k)) Preferences.set({ key: k, value: String(v) });
  };
  localStorage.removeItem = (k) => {
    origRemove(k);
    if (KEYS.includes(k)) Preferences.remove({ key: k });
  };
  localStorage.clear = () => {
    origClear();
    KEYS.forEach((k) => Preferences.remove({ key: k }));
  };

  // 3) Tombol Back Android → history back; kalau di root, keluar aplikasi.
  App.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack || window.history.length > 1) window.history.back();
    else App.exitApp();
  });

  // 4) Status bar rapi (opsional; abaikan bila plugin tak ada).
  try { if (StatusBar) await StatusBar.setStyle({ style: Style.Light }); } catch (_) {}
}

// Dipanggil dari AuthContext idle-logout / logout manual bila mau memastikan
// token native ikut terhapus (localStorage.clear sudah menanganinya, ini cadangan).
export async function clearNativeAuth() {
  if (!native) return;
  const { Preferences } = await import('@capacitor/preferences');
  await Promise.all(KEYS.map((k) => Preferences.remove({ key: k })));
}
